import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Canonical className combiner used across every component. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
